import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { StepperActualizacionService } from '@services/shared/stepper-actualizacion.service';

export interface PasoStepper {
    estado: number;
    label: string;
    descripcion?: string;
    icon?: string;
    rejected?: boolean;
}

@Component({
    selector: 'app-stepper',
    templateUrl: './stepper.component.html',
    styleUrls: ['./stepper.component.scss'],
})
export class StepperComponent implements OnInit {
    @Input() stepperSet: number;
    @Input() vertical: boolean;
    @Input() mostrarRecupero: boolean = false;

    /**
     * Pasos propios. Si se pasan, pisan los pasos por defecto (que están
     * redactados para el afiliado). Opt-in: sin valor, el comportamiento
     * es el de siempre.
     */
    @Input() pasosCustom: PasoStepper[] | null = null;

    /**
     * Modo explicativo: no marca progreso. Todos los pasos se dibujan en rosa
     * con su número (o ícono), sin ticks de "completado".
     */
    @Input() sinProgreso: boolean = false;

    flagLoaded = false;

    step0Completed = false;
    step1Completed = false;
    step2Completed = false;
    step3Completed = false;
    step4Completed = false;
    step5Completed = false;

    idioma: Subscription;

    get esAnulado(): boolean {
        return this.stepperSet === 5;
    }

    // Pasos del stepper. Si mostrarRecupero, se agrega Recupero como paso previo a Auditoría.
    // El último paso es el terminal: Aprobado (4) o Anulado (5).
    get pasos(): PasoStepper[] {
        if (this.pasosCustom && this.pasosCustom.length) {
            return this.pasosCustom;
        }

        const base: PasoStepper[] = [
            {
                estado: 0,
                label: 'Presentado',
                descripcion: 'Solicitud de aprobación para el trámite seleccionado.',
            },
            {
                estado: 1,
                label: 'Documentación',
                descripcion: 'Cargue la documentación necesaria para continuar.',
            },
            {
                estado: 2,
                label: 'En Revisión',
                descripcion:
                    'Su documentación fue presentada con éxito y se encuentra en estado de REVISIÓN.',
            },
        ];

        if (this.mostrarRecupero) {
            base.push({
                estado: 7,
                label: 'Recupero',
                icon: 'autorenew',
                descripcion: 'Su solicitud se encuentra en gestión de Recupero.',
            });
        }

        base.push(
            {
                estado: 3,
                label: 'En Auditoría Médica',
                descripcion: 'La documentación está siendo evaluada por auditoría médica.',
            },
            this.esAnulado
                ? {
                      estado: 5,
                      label: 'Anulado',
                      icon: 'block',
                      rejected: true,
                      descripcion: 'Su trámite ha sido ANULADO.',
                  }
                : {
                      estado: 4,
                      label: 'Aprobado',
                      descripcion: '¡Felicitaciones! Su trámite fue aprobado.',
                  }
        );

        return base;
    }

    get pasoActualIndex(): number {
        return this.pasos.findIndex((p) => p.estado === this.stepperSet);
    }

    estadoPaso(index: number): 'done' | 'current' | 'pending' {
        if (this.sinProgreso) {
            return 'pending';
        }
        const actual = this.pasoActualIndex;
        if (actual === -1) {
            return 'pending';
        }
        if (index < actual) {
            return 'done';
        }
        if (index === actual) {
            return 'current';
        }
        return 'pending';
    }

    constructor(private stepActualizacionService: StepperActualizacionService) {}

    ngOnInit(): void {
        this.stepActualizacionService.estadoSolicitud$.subscribe((nuevoEstado) => {
            if (nuevoEstado !== null) {
                this.setEstadosStepper(nuevoEstado);
            }
        });
    }

    setEstadosStepper(stepperSet: number): void {
        this.step0Completed = true;
        this.step1Completed = stepperSet >= 1;
        this.step2Completed = stepperSet >= 2;
        this.step3Completed = stepperSet >= 3;
        this.step4Completed = stepperSet >= 4;
        this.step5Completed = stepperSet >= 5;
        this.flagLoaded = true;
    }
}
